<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><span class="txbf">CONTENTS</span></h2>
<p class="FMH"><span class="gray"><a href="#/xhtml/book1">Twisted</a></span></p>
<p class="FMHs"><a href="#/xhtml/part1">Gaia</a></p>
<p class="FMHs1"><a href="#/xhtml/ch01">The High School Circle</a></p>
<p class="FMHs"><a href="#/xhtml/part2">Gaia</a></p>
<p class="FMHs1"><a href="#/xhtml/ch02">Painfully Beautiful</a></p>
<p class="FMHs"><a href="#/xhtml/part3">Ed</a></p>
<p class="FMHs1"><a href="#/xhtml/ch03">The Gaia Flu</a></p>
<p class="FMHs1"><span href="#/xhtml/ch04" title="Link target outside of Sample">Numbering The Dead</span></p>
<p class="FMHs1"><span href="#/xhtml/ch05" title="Link target outside of Sample">Chalk</span></p>
<p class="FMHs"><span href="#/xhtml/part4" title="Link target outside of Sample">Sam</span></p>
<p class="FMHs1"><span href="#/xhtml/ch06" title="Link target outside of Sample">The Connection</span></p>
<p class="FMHs"><span href="#/xhtml/part5" title="Link target outside of Sample">Tom Moore</span></p>
<p class="FMHs1"><span href="#/xhtml/ch07" title="Link target outside of Sample">Mary</span></p>
<p class="FMHs1"><span href="#/xhtml/ch08" title="Link target outside of Sample">Genuine Monsters</span></p>
<p class="FMHs"><span href="#/xhtml/part6" title="Link target outside of Sample">Mary</span></p>
<p class="FMHs1"><span href="#/xhtml/ch09" title="Link target outside of Sample">A Simple Job</span></p>
<p class="FMHs1"><span href="#/xhtml/ch10" title="Link target outside of Sample">Stranger</span></p>
<p class="FMHs1"><span href="#/xhtml/ch11" title="Link target outside of Sample">David</span></p>
<p class="FMHs1"><span href="#/xhtml/ch12" title="Link target outside of Sample">Double Dare</span></p>
<p class="FMHs1"><span href="#/xhtml/ch13" title="Link target outside of Sample">The Gentleman</span></p>
<p class="FMHs1"><span href="#/xhtml/ch14" title="Link target outside of Sample">A Time to Die</span></p>
<p class="FMHs"><span href="#/xhtml/part7" title="Link target outside of Sample">Gaia</span></p>
<p class="FMH"><span class="gray"><span href="#/xhtml/book2" title="Link target outside of Sample">Kiss</span></span></p>
<p class="FMHs"><span href="#/xhtml/part8" title="Link target outside of Sample">Gaia</span></p>
<p class="FMHs1"><span href="#/xhtml/ch15" title="Link target outside of Sample">The Color of Fear</span></p>
<p class="FMHs"><span href="#/xhtml/part9" title="Link target outside of Sample">Sam</span></p>
<p class="FMHs1"><span href="#/xhtml/ch16" title="Link target outside of Sample">Hell Hath no Fury . . .</span></p>
<p class="FMHs"><span href="#/xhtml/part10" title="Link target outside of Sample">Mary Moss</span></p>
<p class="FMHs1"><span href="#/xhtml/ch17" title="Link target outside of Sample"> . . . Like A Woman Scorned</span></p>
<p class="FMHs"><span href="#/xhtml/part11" title="Link target outside of Sample">Gaia</span></p>
<p class="FMHs1"><span href="#/xhtml/ch18" title="Link target outside of Sample">A Reason to Stay</span></p>
<p class="FMHs1"><span href="#/xhtml/ch19" title="Link target outside of Sample">Fun For A Change</span></p>
<p class="FMHs"><span href="#/xhtml/part12" title="Link target outside of Sample">Ed</span></p>
<p class="FMHs1"><span href="#/xhtml/ch20" title="Link target outside of Sample">Too Nice</span></p>
<p class="FMHs1"><span href="#/xhtml/ch21" title="Link target outside of Sample">Pennsylvania Station</span></p>
<p class="FMHs"><span href="#/xhtml/part13" title="Link target outside of Sample">Gaia</span></p>
<p class="FMHs1"><span href="#/xhtml/ch22" title="Link target outside of Sample">Not A Penny</span></p>
<p class="FMHs1"><span href="#/xhtml/ch23" title="Link target outside of Sample">Freedom/Nothingness</span></p>
<p class="FMHs1"><span href="#/xhtml/ch24" title="Link target outside of Sample">The Color of Love</span></p>
<p class="FMHs"><span href="#/xhtml/part14" title="Link target outside of Sample">Heather</span></p>
<p class="FMHs1"><span href="#/xhtml/ch25" title="Link target outside of Sample">Hunger</span></p>
<p class="FMHs"><span href="#/xhtml/part15" title="Link target outside of Sample">Sam</span></p>
<p class="FMHs"><span href="#/xhtml/part16" title="Link target outside of Sample">Gaia</span></p>
<p class="FMH"><span class="gray"><span href="#/xhtml/book3" title="Link target outside of Sample">Payback</span></span></p>
<p class="FMHs"><span href="#/xhtml/part17" title="Link target outside of Sample">Gaia</span></p>
<p class="FMHs1"><span href="#/xhtml/ch26" title="Link target outside of Sample">Think About Sam</span></p>
<p class="FMHs"><span href="#/xhtml/part18" title="Link target outside of Sample">Tom Moore</span></p>
<p class="FMHs1"><span href="#/xhtml/ch27" title="Link target outside of Sample">Still no Call</span></p>
<p class="FMHs"><span href="#/xhtml/part19" title="Link target outside of Sample">Romeo</span></p>
<p class="FMHs1"><span href="#/xhtml/ch28" title="Link target outside of Sample">Gaia The Brave</span></p>
<p class="FMHs1"><span href="#/xhtml/ch29" title="Link target outside of Sample">Ready and Willing</span></p>
<p class="FMHs"><span href="#/xhtml/part20" title="Link target outside of Sample">Romeo</span></p>
<p class="FMHs1"><span href="#/xhtml/ch30" title="Link target outside of Sample">Inconspicuous</span></p>
<p class="FMHs1"><span href="#/xhtml/ch31" title="Link target outside of Sample">Tired Heather</span></p>
<p class="FMHs"><span href="#/xhtml/part21" title="Link target outside of Sample">Romeo</span></p>
<p class="FMHs1"><span href="#/xhtml/ch32" title="Link target outside of Sample">Indispensable</span></p>
<p class="FMHs"><span href="#/xhtml/part22" title="Link target outside of Sample">Heather</span></p>
<p class="FMHs1"><span href="#/xhtml/ch33" title="Link target outside of Sample">Vulnerable</span></p>
<p class="FMHs"><span href="#/xhtml/part23" title="Link target outside of Sample">Romeo</span></p>
<p class="FMHs1"><span href="#/xhtml/ch34" title="Link target outside of Sample">Damn Scary</span></p>
<p class="FMHs1"><span href="#/xhtml/ch35" title="Link target outside of Sample">The Attack</span></p>
<p class="FMHs"><span href="#/xhtml/part24" title="Link target outside of Sample">Gaia</span></p>
<p class="FMHs1"><span href="#/xhtml/ch36" title="Link target outside of Sample">Miss Popularity</span></p>
<p class="FMHs1"><span href="#/xhtml/ch37" title="Link target outside of Sample">The Sex Ring</span></p>
<p class="FMHs1"><span href="#/xhtml/ch38" title="Link target outside of Sample">Operation Exposure</span></p>
<p class="FMHs"><span href="#/xhtml/part25" title="Link target outside of Sample">Gaia</span></p>
<p class="FMHs1"><span href="#/xhtml/ch39" title="Link target outside of Sample">Her Kind of Game</span></p>
<p class="FMH"><span href="#/xhtml/abt" title="Link target outside of Sample">About The Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?625bc9ae